import * as _ from 'lodash';

import ICalibrationSetTableFieldAttribute = ZoneIQCalibration.ICalibrationSetTableFieldAttribute;
import { AttributeModel } from '../common-models/attribute.model';

export class CalibrationSetTableFieldAttribute extends AttributeModel implements ICalibrationSetTableFieldAttribute {
    public Id?: number;
    public ParentId?: number;
    public ParentType?: number;
    public TableFieldId?: number;
    public TableFieldOption?: number;

    constructor(data: any) {
        super(data, [
            'Id',
            'ParentId',
            'ParentType',
            'TableFieldId',
            'TableFieldOption',
            'AttributeType',
            'AttributeValue',
            'Description',
            'IsEnabled',
            'importValidationResult'
        ]);
    }

    static factory(data: ICalibrationSetTableFieldAttribute) {
        return new CalibrationSetTableFieldAttribute(data);
    }
}
